<template>
  <div id="profile">
    <div id="page-content-wrapper" class="admin-content-area">
      <div class="page-name">
        <div class="page-title"> Profile</div>
      </div>
      <div class="container-fluid">
        <div class="admin-page-content profile-page">
          <section class="internal-container border-top-table-fl">
            <div :class="`loader${loaderClass}`" v-show="loading"></div>
            <div class="pull-right password-change mb-3 ml-3">
              <router-link class="color-blue" v-bind:to="'password/change?email='+ encodeEmail">
                <i class="fp-edit"></i>
                Change Password
              </router-link>
            </div>
            <div class="profile-top-container clear">
              <div class="row">
                <div class="col-md-6">
                  <p class="customer-detail-top"><b class="font-bold"> User Name:- </b> <span class="no-translate">{{ contactName }}</span></p>
                  <p class="no-translate"><img src="/static/images/message.png" class="message" alt=""> <a
                    :href="getValidEmail() ">{{ email }} </a></p>
                  <div class="d-flex align-items-center">
                    <img src="/static/images/call.png" height="24" alt="Phone">
                    <div class="d-flex align-items-center w-100">
                      <div class="pl-0 pr-0 flex-grow-0">
                        <span v-show="!updateProfileClicked">{{ formattedPhone }}</span>
                        <input v-show="updateProfileClicked" type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="updatePhone"
                          placeholder="Phone Number" ref="phoneInput" name="phone_no" @keypress="isNumber($event)">
                      </div>
                      <div class="pl-0 flex-grow-0 d-flex align-items-center ml-4">
                        <button v-show="!updateProfileClicked" class="btn btn-primary" @click="editProfile()" type="button">Edit</button>
                        <button v-show="updateProfileClicked" class="btn btn-primary ml-2" @click="updateProfileApi()" type="button">Update</button>
                        <p id="profile-saved-text" class="ml-2 m-0 p-0 hide" style="color: green;">Saved</p>
                      </div>
                    </div>
                  </div>
                  <div v-if="updatePhoneErrorMsg" class="field-error" style="margin-left: 35px;">{{ updatePhoneErrorMsg }}</div>
                </div>
                <div class="col-md-6">
                  <p class="customer-detail-top"><b class="font-bold"> My Dealer Assignments:-</b></p>
                  <div class="mb-3">
                    <table class="custom-table">
                      <thead>
                        <tr>
                          <th>Dealer Code</th>
                          <th>Dealer Name</th>
                        </tr>
                      </thead>
                      <tbody class="no-translate">
                        <tr v-if="dealerArr.length === 0">
                          <td colspan="2">No data available</td>
                        </tr>
                        <tr v-else v-for="dealer in dealerArr" :key="dealer.code">
                          <td>{{ dealer.code }}</td>
                          <td>{{ dealer.name }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <hr class="light-hr"/>
              <div class="row">
                <div class="col-md-6" v-if="userRole == 'customer'">
                  <div class="mb-3"><b class="font-bold">{{ userType }} Type:</b> &nbsp;{{ type }}</div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="font-bold"> Credit Limit</div>
                      <p> ${{ credit_limit }}</p>
                    </div>
                    <div class="col-md-6">
                      <div class="font-bold"> Available Credit</div>
                      <p> ${{ available_credit }} </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" v-if="userRole != 'customer'">
                  <div><b class="font-bold"> User Role:</b> &nbsp;<span class="no-translate">{{ type.toUpperCase() }}</span></div>
                </div>
              </div>
              <hr class="light-hr"/>
              <div class="row">
                <div class="col-md-4">
                  <h4>Sidebar Setting</h4>
                  <div class="mb-3">
                    <label for="sidebar_toggle">Expand Sidebar (Default)</label>
                    <v-select v-model="sidebar_toggle" id="sidebar_toggle" name="sidebar_toggle" placeholder="Select"
                              label="text" @change="sidebarToggleChanged($event)"
                              :options="sidebarToggleArr" :searchable="false">
                    </v-select>
                    <div class="field-error">{{ sidebar_toggle_err_msg }}</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <h4>Default Language</h4>
                  <div class="mb-3">
                    <label for="default_lang">Language (Default)</label>
                    <v-select class="no-translate" v-model="default_lang" id="default_lang" name="default_lang" placeholder="Select"
                              label="text" @change="languageChanged($event)"
                              :options="languageArr" :searchable="false">
                    </v-select>
                    <div class="field-error">{{ default_lang_err_msg }}</div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-4">
                  <h4>Automatic Email Notification</h4>
                  <div class="mb-3">
                    <label for="auto_email_notification">Automatic Email Notification</label>
                    <v-select v-model="auto_email_notification" id="auto_email_notification" name="auto_email_notification" placeholder="Select"
                              label="text" @change="autoEmailChanged($event)"
                              :options="autoNotificationArr" :searchable="false">
                    </v-select>
                    <div class="field-error">{{ auto_email_notification_err_msg }}</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <button v-on:click="changeSidebarToggle()" class="btn btn-primary">Save</button><span id="saved-text" class="ml-2 hide" style="color: green;">Saved</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import EventBus from "@/components/event-bus";

export default {
  name: "profile-details",
  mixins: [commonMixins],
  data: () => ({
    companyName: "",
    // options:['PICKUP','DROPOFF'],
    contact: "",
    usercity: "",
    title: "",
    userstate: "",
    address: "",
    contactName: "",
    adminCan: false,
    userRole: "",
    userType: "Customer",
    postcode: "",
    user_number: "",
    flag: "",
    type: "",
    fax: "",
    credit_limit: "",
    available_credit: "",
    email: "",
    encodeEmail: "",
    loading: false,
    userpin: "",
    sidebar_toggle: '',
    sidebar_toggle_err_msg: '',
    sidebarToggleArr: ['Yes', 'No'],
    userObj: null,
    dealerArr: [],
    autoNotificationArr: [
      { value: 'yes', text: 'Yes, I want to receive emails with updates' },
      { value: 'no', text: 'No, I do not want to receive emails updates' }
    ],
    auto_email_notification: '',
    auto_email_notification_err_msg: '',
    updatePhone: '',
    updatePhoneErrorMsg: '',
    updateProfileClicked: false,
    languageArr: Object.entries({
      "en": "English",
      "es": "Spanish",
      "fr": "French",
      "hi": "Hindi",
      "zh-CN": "Chinese"
    }).map(([value, text]) => ({ text, value })),
    default_lang: '',
    default_lang_err_msg: ''
  }),


  mounted: function () {
    var self = this;

    self.userObj = localStorage.getItem("user_obj");
    var role = null;

    //if user logged in than remove login button and registration button
    if (self.userObj != null) {
      var userJson = JSON.parse(self.userObj);
      if (userJson.roles.length > 0) {
        role = userJson.roles[0].name;
        this.userRole = userJson.roles[0].name;

        this.loggedinUserId = userJson.id;
      }
    }
    self.loadUserDealerMapper(this.loggedinUserId);

    if (this.userRole != 'customer') {
      this.adminCan = true;
      this.userType = 'User';
    }
    this.getUserDetails();
    this.getPermissions();
  },
  computed: {
    formattedPhone() {
      if (!this.contact) return "";
      return this.contact.replace(/(\d{3})(\d{2,3})(\d{2,4})/, "$1-$2-$3");
    }
  },
  methods: {
    editProfile() {
      this.updateProfileClicked = true;
      if (this.contact !== 'Not Available') {
        this.$nextTick(() => {
          this.$refs.phoneInput.cleave.setRawValue(this.contact);
          // Capture the formatted value Cleave.js applied
          this.updatePhone = this.$refs.phoneInput.cleave.getFormattedValue();
        });
      }
    },
    updateProfileApi(){
      var self = this;      
      var success = true;

      self.updatePhoneErrorMsg = '';
      if(self.updatePhone === '' || self.updatePhone === null) {
        self.updatePhoneErrorMsg = 'Phone is required.';
        success = false;
      } else {
        var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        if(!self.updatePhone.match(phoneRE)){
          self.updatePhoneErrorMsg = "Please enter valid phone number";
          success = false;
        }
      }

      if(success) {
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/user/update-profile",
          type: "POST",
          headers: self.ajxHeaders,
          crossDomain: true,
          data: {
            id: self.loggedinUserId,
            phone: self.$refs.phoneInput.cleave.getRawValue()
          },
          dataType: 'json',
          success: function (data) {
            self.loading = false;            
            if (data.code == 200) {
              $("#profile-saved-text").removeClass("hide");
              $("#profile-saved-text").addClass("show");
              setTimeout(() => {
                $("#profile-saved-text").removeClass("show");
                $("#profile-saved-text").addClass("hide");
              }, 2000);
              self.contact = data.content.work_phone;
              self.updateProfileClicked = false;
              // Reapply Cleave.js formatting
              self.$nextTick(() => {
                if (self.$refs.phoneInput) {
                  self.$refs.phoneInput.cleave.setRawValue(self.updatePhone);
                }
              });
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, false, 'update-profile');
          }
        });
      }
    },
    sidebarToggleChanged(value) {
      if (value == null || value == '') {
        this.sidebar_toggle = '';
      }
    },
    languageChanged(value) {
      if (value == null || value == '') {
        this.default_lang = '';
      }
    },
    autoEmailChanged(value) {
      if (value == null || value == '') {
        this.auto_email_notification = '';
      }
    },
    changeSidebarToggle() {
      var self = this;
      var success = true;
      self.sidebar_toggle_err_msg = "";
      if (self.sidebar_toggle == '' || self.sidebar_toggle == null) {
        self.sidebar_toggle_err_msg = "Please select one option";
        success = false;
      }

      if (self.auto_email_notification == '' || self.auto_email_notification == null) {
        self.auto_email_notification_err_msg = "Please select one option";
        success = false;
      }

      if (self.default_lang == '' || self.default_lang == null) {
        self.default_lang_err_msg = "Please select one option";
        success = false;
      }

      if (
        success 
        && 
        self.loggedinUserId 
      ) {
        const autoEmailNotification = self.auto_email_notification.value == 'yes' ? 1 : 0;
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/user/change_sidebar_toggle",
          type: "POST",
          headers: self.ajxHeaders,
          crossDomain: true,
          data: {
            id: self.loggedinUserId,
            sidebarToggle: self.sidebar_toggle == 'Yes' ? 1 : 0,
            autoEmailNotification: autoEmailNotification,
            defaultLang: self.default_lang.value
          },
          dataType: 'json',
          success: function (data) {
            self.loading = false;            
            if (data.code == 200) {
                $("#saved-text").removeClass("hide");
                $("#saved-text").addClass("show");
                setTimeout(() => {
                  $("#saved-text").removeClass("show");
                  $("#saved-text").addClass("hide");
                }, 2000);
              if(data.content.auto_email_notification && data.content.auto_email_notification == 1) {
                self.auto_email_notification = {
                  value: 'yes',
                  text: 'Yes, I want to receive emails with updates'
                };
              } else {
                self.auto_email_notification = {
                  value: 'no',
                  text: 'No, I do not want to receive emails updates'
                };
              }
              // Retrieve the array from local storage
              if (self.userObj !== null) {
                var userJson = JSON.parse(self.userObj);
                userJson.sidebar_toggle = data.content.sidebar_toggle;
                localStorage.setItem('user_obj', JSON.stringify(userJson));
              }
              self.emitSidebarToParent(data.content.sidebar_toggle);
              localStorage.setItem('selectedLang', self.default_lang.value);
              EventBus.$emit('translate-lang-event', self.default_lang.value);
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            if (jqXHR.status == 0) {
              self.registerError = "Remote server cannot be reached";
            } else {
              if (jqXHR.status == 401) {
                //clear previous data
                localStorage.removeItem('user_obj');
                localStorage.removeItem('api_token');
                self.$router.push("/login");
              }
            }
          }
        });
      }
    },
    emitSidebarToParent(sidebarvalue) {
      if (sidebarvalue == 1) {
        this.$parent.sidebarToggle = true;
      } else {
        this.$parent.sidebarToggle = false;
      }
    },
    getUserDetails: function () {
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/user-profile/" + self.loggedinUserId,
        type: "get",
        headers: this.ajxHeaders,
        crossDomain: true,
        data: {flag: "profile"},
        dataType: 'json',
        success: function (data) {          
          self.loading = false;
          self.Registeruserbtn = "UPDATE";
          self.userpin = btoa(data.content.user_pin);
          if (data.status == "success") {
            self.contactData = data.content;
            self.company = self.contactData.company;
            if (self.contactData.first_name != '') {
              self.contactName = self.jsUcfirst(self.contactData.first_name) + " " + self.jsUcfirst(self.contactData.last_name);
            } else {
              self.contactName = 'Not Available';
            }
            if(data.content.auto_email_notification && data.content.auto_email_notification == 1) {
              self.auto_email_notification = {
                value: 'yes',
                text: 'Yes, I want to receive emails with updates'
              };
            } else {
              self.auto_email_notification = {
                value: 'no',
                text: 'No, I do not want to receive emails updates'
              };
            }
            // self.dot = self.contactData.dot;
            if (self.contactData.work_phone != '') {
              self.contact = self.contactData.work_phone;
            } else {
              self.contact = 'Not Available';
            }
            if (self.contactData.email != '') {
              self.email = self.contactData.email;
              self.encodeEmail = btoa(self.contactData.email);
            } else {
              self.email = '';
              self.encodeEmail = btoa(self.contactData.username);
            }
            if (
              (self.contactData.cityName == null || self.contactData.cityName == '')
              &&
              (self.contactData.stateName == null || self.contactData.stateName == '')
              &&
              (self.contactData.address_1 == null || self.contactData.address_1 == '')
            ) {
              self.address = 'Not Available';
            } else {
              self.usercity = self.contactData.cityName;
              self.userstate = self.contactData.stateName;
              self.address = self.contactData.address_1;
            }

            if (self.contactData.zip == null || self.contactData.zip == '') {
              self.postcode = 'Not Available';
            } else {
              self.postcode = self.contactData.zip;
            }
            if (self.contactData.fax != null) {
              self.fax = self.contactData.fax;
            } else {
              self.fax = 'Not Available';
            }
            self.type = self.userRole;
            if (self.contactData.employee_no == null || self.contactData.employee_no == '') {
              self.user_number = 'Not Available';
            } else {
              self.user_number = self.contactData.employee_no;
            }
            if (self.contactData.credit_limit != null && self.contactData.credit_limit != '') {

              self.credit_limit = self.numberFormat(self.contactData.credit_limit);
            } else {
              self.credit_limit = self.numberFormat(0);
            }
            if (self.contactData.available_credit != null && self.contactData.available_credit != '') {
              self.available_credit = self.numberFormat(self.contactData.available_credit);
            } else {
              self.available_credit = self.numberFormat(0);
            }
            if (self.contactData.sidebar_toggle) {
              self.sidebar_toggle = "Yes";
            } else {
              self.sidebar_toggle = "No";
            }
            if(self.contactData.default_translate_lang){
              const matchedLang = self.languageArr.find(lang => lang.value === self.contactData.default_translate_lang);
              self.default_lang = matchedLang || self.languageArr.find(lang => lang.value === 'en');
            }
            } else if (data.status == "error") {

            if (data.code == "201") {
              self.formerrors.push('Access Denied');
              self.msgClass = "error";
            }
          }

        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.Registeruserbtn = "ADD";
          if (jqXHR.status == 0) {
            self.registerError = "Remote server cannot be reached";
          } else {
            if (jqXHR.status == 401) {
              //clear previous data
              self.inspectionbtn = "Load More";
              localStorage.removeItem('user_obj');
              localStorage.removeItem('api_token');
              self.$router.push("/login");
            }
          }
        }
      });
    },

    jsUcfirst: function (string) {
      if (string !== "" && string != null) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      } else {
        return "";
      }
    },
    getValidEmail() {
      if (this.email && this.email.trim() !== "") {
        if (!this.validEmail(this.email)) {
          console.warn("Invalid Email Detected!", this.email)
          return "";
        } else {
          return 'mailto:' + this.email;
        }
      }
    }
  }
};
</script>
<style scoped>
.custom-table {
    width: 100%;
    border-collapse: collapse;
    font-weight: bold;
}

.custom-table th,
.custom-table td {
    border: 1px solid black;
    padding: 2px;
    text-align: center;
}
.custom-table thead {
  background-color: var(--color-orange-rizon);
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Profile.vue